import { JavaObject } from '../../java/lang/JavaObject';
import { IllegalStateException } from '../../java/lang/IllegalStateException';
import { Class } from '../../java/lang/Class';
import { JavaString } from '../../java/lang/JavaString';

export class AdressenUtils extends JavaObject {


	private constructor() {
		super();
		throw new IllegalStateException("Instantiation not allowed")
	}

	/**
	 * Teilt eine Straßenangabe bestehend aus dem
	 * Strassennamen, der Hausnummer und dem Hausnummerzusatz
	 * in die Bestandteile auf. Zu lange Angaben werden automatisch getrimmt.
	 *
	 * In TS kann man diese Funktion sehr schön auf diese Weise verwenden,
	 * da die Attribute in den verwendeten Klassen ebenso benannt sind:
	 * `const [ strassenname, hausnummer, hausnummerZusatz ] = AdressenUtils.splitStrasse(value);`
	 *
	 * @param strasse   die Strassenangabe
	 *
	 * @return ein Array mit den 3 Elementen (0 - Strassennamen (max. 55 Zeichen), 1 - Hausnummer (max. 10 Zeichen) und 2 - Hausnummerzusatz (max.30 Zeichen))
	 */
	public static splitAndTrimStrasse(strasse: string | null): Array<string> {
		const result: Array<string> = AdressenUtils.splitStrasse(strasse);
		if (result[0].length > 55) {
			result[0] = result[0].substring(0, 55);
		}
		if (result[1].length > 10) {
			result[1] = result[1].substring(0, 10);
		}
		if (result[2].length > 30) {
			result[2] = result[2].substring(0, 30);
		}
		return result;
	}

	/**
	 * Teilt eine Straßenangabe bestehend aus dem
	 * Strassennamen, der Hausnummer und dem Hausnummerzusatz
	 * in die Bestandteile auf.
	 *
	 * In TS kann man diese Funktion sehr schön auf diese Weise verwenden,
	 * da die Attribute in den verwendeten Klassen ebenso benannt sind:
	 * `const [ strassenname, hausnummer, hausnummerZusatz ] = AdressenUtils.splitStrasse(value);`
	 *
	 * @param strasse   die Strassenangabe
	 *
	 * @return ein Array mit den 3 Elementen (0 - Strassennamen, 1 - Hausnummer und 2 - Hausnummerzusatz)
	 */
	public static splitStrasse(strasse: string | null): Array<string> {
		const result: Array<string> = Array(3).fill(null);
		if (strasse === null) {
			result[0] = "";
			result[1] = "";
			result[2] = "";
			return result;
		}
		const tmp: string = JavaString.replace(JavaString.replace(JavaString.replace(JavaString.replace(strasse.trim(), "  ", " "), "  ", " "), " -", "-"), "- ", "-");
		result[0] = JavaString.replaceFirst(tmp, " *(\\d+ *[-\\+]+)* *\\d+\\D*$", "");
		const rest: string = tmp.substring(result[0].length).trim();
		result[1] = JavaString.replaceFirst(rest, "\\D*$", "").trim();
		result[2] = rest.substring(result[1].length).trim();
		return result;
	}

	/**
	 * Kombiniert die übergebenen Werte für den Strassennamen, die Hausnummer und
	 * den Zusatz zu einer Strassenangabe in einem String.
	 *
	 * @param name         der Strassenname
	 * @param hausNummer   die Hausnummer
	 * @param zusatz       der Hausnummerzusatz
	 *
	 * @return die kombinierte Strassenangabe
	 */
	public static combineStrasse(name: string | null, hausNummer: string | null, zusatz: string | null): string | null {
		if ((name === null) || (hausNummer === null) || (zusatz === null)) {
			return null;
		}
		if (JavaObject.equalsTranspiler("", (hausNummer.trim())) && (JavaObject.equalsTranspiler("", (zusatz.trim())))) {
			return name;
		}
		return name + " " + hausNummer.trim() + zusatz.trim();
	}

	transpilerCanonicalName(): string {
		return 'de.svws_nrw.core.utils.AdressenUtils';
	}

	isTranspiledInstanceOf(name: string): boolean {
		return ['de.svws_nrw.core.utils.AdressenUtils'].includes(name);
	}

	public static readonly class = new Class<AdressenUtils>('de.svws_nrw.core.utils.AdressenUtils');

}

export function cast_de_svws_nrw_core_utils_AdressenUtils(obj: unknown): AdressenUtils {
	return obj as AdressenUtils;
}
